import classnames from 'classnames'

import { Button } from '../../main/components/button'
import { encodeQueryString } from '../queryString'
import { getIsDrawingEnabledOnQuotePage, setIsDrawingEnabledOnQuotePage } from '../shared/utils'

interface Props {
  isPremium: boolean
}

export default function Draw({ isPremium }: Props) {
  const isDrawingEnabled = getIsDrawingEnabledOnQuotePage()
  return (
    <Button
      size="regular"
      rounding="none"
      leftContent="gesture"
      className={classnames('btn', 'flex items-center !px-3', { 'is-primary': isDrawingEnabled })}
      onClick={(e: React.MouseEvent) => {
        e.preventDefault()

        if (isPremium) {
          setIsDrawingEnabledOnQuotePage(!isDrawingEnabled)
        } else {
          document.location = `/elite.ashx?${encodeQueryString({
            utm_source: 'finviz',
            utm_medium: 'banner',
            utm_campaign: 'quote-draw-button',
          })}`
        }
      }}
      data-testid="quote-toggle-draw-btn"
    >
      <span>Draw</span>
    </Button>
  )
}
